import React from 'react';

export default function Header() {
  return (
    <header style={{ padding: '2rem 16rem', background: 'var(--polynesian-blue)', color: 'white', fontSize: '24px', fontWeight: 'bold' }}>
      Causality
    </header>
  );
}
